<template>
  <div v-if="parentPortalOptions != null" id="show-client-portal-technical">
    <v-card class="mt-3">
      <v-card-title>
        Configuration Portail Technique
        <v-spacer></v-spacer>
        <v-btn @click="dialog = true" color="primary" icon>
          <v-icon>mdi-cog</v-icon>
        </v-btn>
        <edit-portal-options-dialog
          v-if="dialog == true"
          :open.sync="dialog"
          :portal-options.sync="parentPortalOptions"
          :profiles="profiles"
          :card-models="cardModels"
        ></edit-portal-options-dialog>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <div v-if="currentBasicProfile != null" class="mt-2">
          <span> BASIC Profile : </span>
          <span class="font-weight-bold">{{ currentBasicProfile.label }}</span>
        </div>
        <div v-if="currentFullProfile != null" class="mt-2">
          <span> FULL Profile :</span>
          <span class="font-weight-bold">{{ currentFullProfile.label }}</span>
        </div>
        <div v-if="currentFreeCardModel != null" class="mt-2">
          <span>Modèle de carte gratuite : </span>
          <span class="font-weight-bold">{{
            currentFreeCardModel.description
          }}</span>
        </div>
        <div class="mt-2">
          <span>TVA : </span>
          <span class="font-weight-bold">{{ parentPortalOptions.vat }}</span>
        </div>
        <div class="mt-2">
          <span>SSL Actif : </span>
          <v-icon v-if="parentPortalOptions.activateSsl" color="success"
            >mdi-check</v-icon
          >
          <v-icon v-else color="error">mdi-close</v-icon>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { toRefs, computed, onMounted } from "@vue/composition-api";
import { usePortalOptions } from "../../composables/portal-options";
import { useCardModel } from "../../composables/card-model";
import { useProfile } from "../../composables/profile";
import EditPortalOptionsDialog from "@/components/PortalOptions/EditPortalOptionsDialog";

export default {
  components: { EditPortalOptionsDialog },
  props: {
    portalOptions: Object,
    partner: Object,
    isPortalProfile: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const parentPortalOptions = computed({
      get: () => props.portalOptions,
      set: (value) => {
        emit("update:portalOptions", value);
      },
    });
    const { updatePortalOptions, portalOptionData } = usePortalOptions();
    const { cardModels, listCardModels } = useCardModel();
    const { profiles, listProfiles } = useProfile();
    const currentBasicProfile = computed(() => {
      return profiles.value.find(
        (element) => element.id == parentPortalOptions.value.basicProfile
      );
    });

    const currentFullProfile = computed(() => {
      return profiles.value.find(
        (element) => element.id == parentPortalOptions.value.fullProfile
      );
    });

    const currentFreeCardModel = computed(() => {
      return cardModels.value.find(
        (element) => element.id == parentPortalOptions.value.freeCardModel
      );
    });

    onMounted(async () => {
      const freeCardOrigin = 3;
      await listCardModels(props.partner.id, freeCardOrigin);
      await listProfiles(props.partner.id);
    });

    return {
      parentPortalOptions,
      updatePortalOptions,
      cardModels,
      profiles,
      ...toRefs(portalOptionData),
      currentBasicProfile,
      currentFullProfile,
      currentFreeCardModel,
    };
  },
};
</script>
